import { render, staticRenderFns } from "./offices.vue?vue&type=template&id=2bedca63&scoped=true&"
import script from "./offices.vue?vue&type=script&lang=js&"
export * from "./offices.vue?vue&type=script&lang=js&"
import style0 from "./offices.vue?vue&type=style&index=0&id=2bedca63&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bedca63",
  null
  
)

export default component.exports